import axios from 'axios';

let baseUrl = "http://api.kpibonus.site";

console.log("Current domain: " + document.domain);

if(document.domain == 'traditionalforce.com' || document.domain == 'app.traditionalforce.com'){
    baseUrl = "https://api.traditionalforce.com";
}

if(document.domain == 'app.kpibonus.com'){
    baseUrl = "https://api.kpibonus.com";
}

axios.defaults.baseURL = baseUrl;

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'Application/json';

if (localStorage.getItem('token') === null || localStorage.getItem('token') === 'undefined') {
    axios.defaults.headers.common['api-token'] = '';
} else {
    axios.defaults.headers.common['api-token'] = localStorage.getItem('token');
}

if (localStorage.getItem('domain') === null || localStorage.getItem('domain') === 'undefined') {
    axios.defaults.headers.common['domain'] = '';
} else {
    axios.defaults.headers.common['domain'] = localStorage.getItem('domain');
}

axios.interceptors.request.use(function (config) { 
    return config;
}, function (error) {
    return Promise.reject(error);
})

axios.interceptors.response.use(function (response) {
    return response.data;
}, function (error) {
    if(error.response !== undefined){
        if (error.response.status === 401) {
            console.log(error.response);
        } else if (error.response.status === 500 || error.response.status === 404 || error.response.status === 400) {
            throw error;
        } else {
            return Promise.reject(error);
        }
    }
    else{
        return Promise.reject(error);
    }
})
